import { useState } from 'react';
import { Grid } from '@mui/material';
import { CategoryDetails } from 'src/models/Category';
import AdminRolesTable from './AdminRolesTable';
import AppPage from 'src/components/AppPage';

const AdminRoles = () => {
  const [AllCategories, setAllCategories] = useState([] as CategoryDetails[]);

  return (
    <AppPage
      title="Admin — Roles"
      heading="Admin Roles"
      description="Configure administrative roles and permissions for your team."
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12}>
          <AdminRolesTable
            AllCategories={AllCategories}
            setAllCategories={setAllCategories}
          />
        </Grid>
      </Grid>
    </AppPage>
  );
};

export default AdminRoles;
